<template>
  <router-link v-if="useVueRouter"
    data-et
    :data-et-action="action"
    :data-et-category="eventTrackedCategory"
    :data-et-label="eventTrackedLabel"
    :class="{'btn' : button}"
    :to="href"
    @click.native="customTrackEvent($event);"
  >
    <slot />
  </router-link>
  <a v-else
    :aria-label="ariaLabel"
    data-et
    :data-et-action="action"
    :data-et-category="eventTrackedCategory"
    :data-et-label="eventTrackedLabel"
    :class="{'btn' : button}"
    :href="href"
    @click="customTrackEvent($event);"
  >
    <slot />
  </a>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      default: 'click'
    },
    button: {
      type: Boolean,
      default: false
    },
    category: {
      type: String,
      default: 'link'
    },
    fbEvent: {
      type: Boolean,
      default: false
    },
    fbEventLabel: {
      type: String
    },
    label: {
      type: String
    },
    href: {
      type: String
    },
    useVueRouter: {
      type: Boolean,
      default: false
    },
    ariaLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    isPDF () {
      if (this.href && this.href.includes('.pdf')) {
        return true
      }
      return false
    },
    eventTrackedCategory () {
      return this.isPDF ? 'PDF' : this.category
    },
    eventTrackedLabel () {
      const eventLabel = this.label || `${this.href} ${this.title}`

      switch (true) {
        case (!this.isDomain && !this.startsWithSlash && this.href !== '/' && !this.hasHash && !this.isTel && !this.isMail) || this.isPDF || this.isTel || this.isMail:
          return this.href
        case this.href === '/':
          return 'Back to homepage'
        default:
          return eventLabel
      }
    }
  },
  data () {
    return {
      hasHash: this.href ? this.href.includes('#') : false,
      isDomain: this.href ? this.href.includes(window.location.hostname) : false,
      isMail: this.href ? this.href.includes('mailto') : false,
      isTel: this.href ? this.href.includes('tel') : false,
      startsWithSlash: this.href ? this.href.startsWith('/') : false,
      title: null
    }
  },
  methods: {
    customTrackEvent (event) {
      // Event
      const eventAction = this.action
      const eventCategory = this.isPDF ? 'PDF' : this.category
      const eventLabel = this.label || `${this.href} ${this.title}`

      // eslint-disable-next-line
      if (this.fbEvent) fbq('trackCustom', this.fbEventLabel)

      switch (true) {
        case (!this.isDomain && !this.startsWithSlash && this.href !== '/' && !this.hasHash && !this.isTel && !this.isMail) || this.isPDF:
          event.preventDefault()
          this.trackEvent(eventCategory, 'click', this.href)
          window.open(this.href)
          return
        case this.href === '/':
          this.trackEvent(eventCategory, 'click', 'Back to homepage')
          return
        case this.isTel:
          this.trackEvent('phone', 'click', this.href)
          return
        case this.isMail:
          this.trackEvent('email', 'click', this.href)
          return
        default:
          this.trackEvent(eventCategory, eventAction, eventLabel)
      }
    },
    addPDFLink () {
      // FIXME: In the event vue router is used, these might be appended more than once
      const isPDF = this.href ? this.href.includes('pdf') : false

      if (isPDF) {
        const pdfLink = this.$el

        pdfLink.insertAdjacentHTML('afterend', '<span class="accessibly-hidden pdf-statement"> This page requires a PDF reader to view some of the content. <a href="https://get.adobe.com/reader/">Download Adobe Acrobat Reader</a>.</span>')
      }
    }
  },
  mounted () {
    this.title = this.$slots.default[0].text || this.$el.innerText.trim()

    this.addPDFLink()
  }
}
</script>
